import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMMSiteModel } from '@apps-common/types/my-monitoring'

export const QUERY_KEY_MY_MONITORING_GET_SITE = (siteId?: string) => ['getMyMonitoringSite', siteId].filter(Boolean)

const getSite = async (siteId?: string): Promise<IMMSiteModel> =>
  axios.get(`/my-monitoring/Sites/GetSite?siteId=${siteId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSite

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId?: string
}

export const useMyMonitoringGetSite = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_SITE(unitId),
    queryFn: () => getSite(unitId)
  })
